import React, { useState } from "react";
import { FaCloudUploadAlt } from 'react-icons/fa'; 
import "./logoUploader.css"; // Import your CSS file for styling

const LogoUploader = ({ onLogoUpload }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    if (file && onLogoUpload) {
      // Create URL without blob prefix
      const fileUrl = URL.createObjectURL(file);
      setFileUrl(fileUrl);
      onLogoUpload(fileUrl); // Sending URL to parent component
    }
  };

  const handleChooseFileClick = () => {
    document.getElementById("fileInput").click();
  };

  return (
    <div className="logo-uploader-container">
      <div className="drag-drop-area" onClick={handleChooseFileClick}>
        {selectedFile ? (
          <img
            src={fileUrl} // Use the URL without blob prefix
            alt="Selected File"
            className="drag-drop-image"
          />
        ) : (
          <>
            <div className="cloud-icon">
              <FaCloudUploadAlt />
            </div>
            <div>Drag n Drop Logo File</div>
          </>
        )}
        <input
          id="fileInput"
          type="file"
          accept=".png, .jpg, .jpeg"
          onChange={handleFileChange}
          style={{ display: "none" }}
        />
      </div>
      {selectedFile && (
        <div className="selected-file-preview">
          <div className="file-name">{selectedFile.name}</div>
        </div>
      )}
    </div>
  );
};

export default LogoUploader;
